const getMayfairVariations = (commonCanopies, commonVariaton) => {
	return {
		'5520': {
			...commonVariaton,
			size: {
				width: 0.30,
				height: 0.48,
				depth: 0.30
			},
			paddingTop: -1,
			familyName: 'mayfair',
			related: ['5520', '5525'],
			canopy: {
				...commonCanopies,
				"10": {
					...commonCanopies['10'],
					source: '/models/canopy_skan.glb',
					size: {
						width: 0.16,
						depth: 0.16,
						height: 0.033
					},
				}
			},
			light: {
				type: 'spot',
				power: 199,
				options: { angle: Math.PI / 8 }
			}
		},
		'5525': {
			...commonVariaton,
			size: {
				width: 0.30,
				height: 0.48,
				depth: 0.30
			},
			paddingTop: -1,
			familyName: 'mayfair',
			related: ['5520', '5525'],
			canopy: {
				...commonCanopies,
				"10": {
					...commonCanopies['10'],
					source: '/models/canopy_skan.glb',
					size: {
						width: 0.16,
						depth: 0.16,
						height: 0.033
					},
				}
			},
			light: {
				type: 'spot',
				power: 199,
				options: { angle: Math.PI / 8 }
			}
		}
	}
}

export default getMayfairVariations